import qs from "qs";

export function useQueryString() {
  return qs.parse(window.location.search, { ignoreQueryPrefix: true });
}
